if (!customElements.get('sc-faq')) {
  customElements.define('sc-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.animations = new Map();
      const { signal } = this.controller;
      this.addEventListener('click', event => {
        const summary = event.target.closest('.sc-faq__question');
        if (!summary || !this.contains(summary)) return;
        event.preventDefault();
        const item = summary.parentElement;
        const expanded = item.dataset.expanded === undefined ? item.open : item.dataset.expanded === 'true';
        if (!expanded) this.querySelectorAll('details[open]').forEach(other => {
          if (other !== item) this.setExpanded(other, false);
        });
        this.setExpanded(item, !expanded);
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.sc-faq__item');
        if (item) this.setExpanded(item, true);
      }, { signal });
    }

    setExpanded(item, expanded) {
      const start = item.getBoundingClientRect().height;
      this.animations.get(item)?.cancel();
      this.animations.delete(item);
      item.dataset.expanded = String(expanded);
      item.querySelector('summary').setAttribute('aria-expanded', String(expanded));
      // Measure the natural end height; interruptions start at the visible height.
      item.open = expanded;
      const end = item.getBoundingClientRect().height;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate || start === end) {
        this.finish(item, expanded);
        return;
      }
      item.open = true;
      const animation = item.animate([{ height: start + 'px' }, { height: end + 'px' }], {
        duration: 320, easing: 'cubic-bezier(.22,1,.36,1)'
      });
      this.animations.set(item, animation);
      animation.onfinish = () => {
        if (this.animations.get(item) !== animation) return;
        this.finish(item, expanded);
        this.animations.delete(item);
        animation.cancel();
      };
    }

    finish(item, expanded) {
      item.open = expanded;
      delete item.dataset.expanded;
      item.querySelector('summary').removeAttribute('aria-expanded');
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.animations?.forEach((animation, item) => {
        animation.cancel();
        this.finish(item, item.dataset.expanded === 'true');
      });
      this.animations?.clear();
    }
  });
}
